import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

const prodConfig = {
  apiKey: "AIzaSyCTLf6SrqLq9DiaAsHBgndwEotfnSnIxIc",
  authDomain: "findmyiphone-9af17.firebaseapp.com",
  databaseURL: "https://findmyiphone-9af17.firebaseio.com",
  projectId: "findmyiphone-9af17",
  storageBucket: "findmyiphone-9af17.appspot.com",
  messagingSenderId: "881322612677"
};

const devConfig = {
  apiKey: "AIzaSyCTLf6SrqLq9DiaAsHBgndwEotfnSnIxIc",
  authDomain: "findmyiphone-9af17.firebaseapp.com",
  databaseURL: "https://findmyiphone-9af17.firebaseio.com",
  projectId: "findmyiphone-9af17",
  storageBucket: "findmyiphone-9af17.appspot.com",
  messagingSenderId: "881322612677"
};

const config = process.env.NODE_ENV === 'production'
  ? prodConfig
  : devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const db = firebase.database();
const auth = firebase.auth();

export {
  db,
  auth,
};



// WEBPACK FOOTER //
// ./src/firebase/firebase.js